export default class ConsultationReportWrittenQuestion {
  constructor(
    public key: string,
    public issue: string,
    public answer: string = ""
  ) {}
}
